import React, { useState } from "react";
import "../css/sidebar.css";
import "../css/Site.css";
import { FaListAlt } from "react-icons/fa";


import 'bootstrap/dist/css/bootstrap.min.css';
require('bootstrap/dist/js/bootstrap.bundle')



export const Sidebar = () => {
  
  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 bg-light" style={{width: 280, height: '100%'}}>
        <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none">
             <span className="fs-4 text-muted">Report Types</span>
        </a>
        <hr />
        <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
            <a href="/" className="nav-link link-dark" aria-current="page">
            <FaListAlt size="20px" className="submit-icon" /> 
            &nbsp; &nbsp; Industry Classfication
            </a>
        </li>
        {/* <li>
            <a href="#" className="nav-link link-dark">
            NAM Board
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            MLC
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            CMA
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            Field/National
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            Accounting
            </a>
        </li>  
        <li>
            <a href="#" className="nav-link link-dark">
            COSMA
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            PMC/Notes
            </a>
        </li>
        <li>
            <a href="#" className="nav-link link-dark">
            Company/Individual
            </a>
        </li>  */}
        </ul>
    </div>
  );
};

